import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EditAreaType from './editAreaType.vue';
import { getListAllTags } from '@blade-sxp/task-management/api/creat-task/index';
import { ZoneTypeModule } from '@blade-sxp/task-management/store/zoneType';
import { isEmpty } from 'lodash';
const Service = {
    getListAllTags,
};
let AreaType = class AreaType extends Vue {
    tagId;
    disabled;
    ruleForm = {
        region: this.$props.tagId,
    };
    editAreaType = false;
    isSelectTotalArea = false;
    selectList = [];
    type = '';
    get rules() {
        return {
            region: [{ required: true, message: this.$t('areaPlaceHolder'), trigger: 'change' }],
        };
    }
    onTagId(nv) {
        // this.selectChange(nv);
    }
    created() {
        const { type } = this.$route.query;
        if (type) {
            this.type = type;
        }
    }
    mounted() {
        this.getDataList();
    }
    setUpdateState() {
        if (this.type === 'update' && this.ruleForm.region && !isEmpty(this.selectList)) {
            const data = this.selectList.filter((item) => item?.id === this.ruleForm.region);
            if (!isEmpty(data) && data[0].type === 'ENTIRE_ZONE') {
                this.isSelectTotalArea = true;
            }
            else {
                this.isSelectTotalArea = false;
            }
        }
    }
    getDataList() {
        this.selectList = [];
        Service.getListAllTags().then((res) => {
            this.selectList = res;
            this.setUpdateState();
            this.selectChange(this.tagId);
            ZoneTypeModule.updataZoneType(this.selectList);
        });
    }
    isDisabled(item) {
        let status = false;
        if (item.type === 'ENTIRE_ZONE') {
            if (item.taskCount === 1) {
                status = true;
            }
            else {
                status = false;
            }
        }
        return status;
    }
    closeEditAreaType() {
        this.editAreaType = false;
        this.getDataList();
    }
    openEditAreaType() {
        this.editAreaType = true;
    }
    selectChange(val) {
        this.$emit('update:tagId', val);
        const selectOption = this.selectList.find((item) => item.id === val);
        if (selectOption) {
            const isTotalArea = selectOption?.type === this.selectList[0].type;
            this.$emit('changeArea', {
                ...selectOption,
                isTotalArea,
            });
        }
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop()
], AreaType.prototype, "tagId", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], AreaType.prototype, "disabled", void 0);
__decorate([
    Watch('tagId', { immediate: true })
], AreaType.prototype, "onTagId", null);
AreaType = __decorate([
    Component({
        name: 'AreaType',
        components: {
            'st-edit-area-type': EditAreaType,
        },
        i18n: {
            messages: {
                zh: {
                    areaType: '区域类型',
                    areaPlaceHolder: '选择区域类型',
                    edit: '编辑',
                },
                en: {
                    areaType: 'Area Type',
                    areaPlaceHolder: 'Select area type',
                    edit: 'Edit',
                },
            },
        },
    })
], AreaType);
export default AreaType;
